// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 11-observability.md#control-plane-internal-health

/**
 * Poll cadence for every live Internal Health read. The collector writes one
 * row per minute, so 30s stays fresh within half a collection tick without
 * hammering the endpoint.
 *
 * Shared rather than per-surface so the snapshot, the updater posture, and the
 * runs list cannot drift apart: a strip whose "next run" is stale while the
 * rest of the card refreshes is worse than one that never claimed to be live.
 */
export const HEALTH_POLL_MS = 30_000;

/**
 * Poll cadence while an updater run is in flight. A run moves through its
 * phases in minutes, so the steady-state cadence would report each one well
 * after it happened — and a card an operator is watching mid-update has to look
 * live to be trusted. Bounded to the surfaces that show an open run.
 */
export const RUN_ACTIVE_POLL_MS = 5_000;

/**
 * Query key for the updater posture. Shared so Internal Health's Updater card
 * and Settings' Maintenance card read one cache entry rather than polling the
 * same route twice.
 */
export const POSTURE_KEY = ['updater-posture'] as const;
